import { render, staticRenderFns } from "./PackingStructureRow.vue?vue&type=template&id=71ad8aa9&scoped=true&"
import script from "./PackingStructureRow.vue?vue&type=script&lang=js&"
export * from "./PackingStructureRow.vue?vue&type=script&lang=js&"
import style0 from "./PackingStructureRow.vue?vue&type=style&index=0&id=71ad8aa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad8aa9",
  null
  
)

export default component.exports